import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const DotIcon = createIcon({
  displayName: 'DotIcon',
  viewBox: '0 0 14 14',
  path: <circle cx="7" cy="7" r="3.5" fill="currentColor" />,
})
